// eslint-disable-next-line import/prefer-default-export
export function validateDomainName(domain: string): boolean {
  if (!domain) {
    return false;
  }

  if (domain.toLowerCase().includes('www.')) {
    return false;
  }

  const regularExpression = /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;
  return regularExpression.test(domain);
}
